import React, { useMemo, useEffect, useState, useRef, useCallback } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';;
import Pagination from '@mui/material/Pagination';
import 'react-circular-progressbar/dist/styles.css';
import LeadService from '../core/services/leadsService';
import toast from 'react-hot-toast';
import { debounce, throttle } from 'lodash';
import { InputAdornment } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import logo_between from '../../public/assets/logo_between.png';
import { makeStyles } from '@mui/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import { useTheme } from '@mui/material/styles';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import ScrollAnimation from 'react-animate-on-scroll';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import {
    Box,
    Button,
    TextField,
    Modal,
    LinearProgress,

} from '@mui/material';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',

}
const useStyles = makeStyles((theme) => ({

    LeadTable: {
        overflowX: 'auto',
        // width: '1310px',
        [theme.breakpoints.down('md')]: {
            overflowX: 'auto',
            // width: '1080px',
        },
        [theme.breakpoints.up('lg')]: {
            overflowX: 'auto',
            // width: '1625px',
        },
        [theme.breakpoints.up('lg')]: {
            overflowX: 'auto',
            // width: '1625px',
        },
        [theme.breakpoints.up('xl')]: {
            overflowX: 'auto',
            width: 'auto',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            // width: '1150px',
        },
    },
    PaginationLeadTable: {
        marginTop: '-40px',
        zIndex: 1000,
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('md')]: {
            overflowX: 'auto',
            // width: '1050px',
        },
    },

}));
const InvitedLeads = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const [LeadData, setLeadData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [viewMode, setViewMode] = useState('list'); // 'list' or 'thumbnail'
    const abortControllerRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [logOutModal, setLogOutModal] = React.useState(false);
    const StatusDisplayMap = {
        active: 'New',
        new: 'New',
        attempting_contact: 'Attempting Contact',
        spoke_with_customer_new: 'New',
        spoke_with_customer: 'Spoke with customer',
        appointment_set: 'Appointment Set',
        met_with_customer: 'Met with Customer',
        showing_homes: 'Showing Homes',
        submitting_offers: 'Submitting Offers',
        buy_side_contract: 'Buy Side Contract',
        under_contract_escrow: 'Under Contract',
        bamfam: 'BAMFAM',
        nurture: 'Nurture Before Sale',
        closed: 'Sale Closed',
        nurture_after_sale: 'Nurture After Sale',
        rejected: 'Rejected',
        not_interested: 'Not Interested',
        personal_lead: 'Personal Lead',
        refinance_referral: 'Refinance Referral',
        agent: 'Agent',
        bad_lead: 'Bad Lead',
        follow_up: 'Follow Up',
        buyer_broker_signed: 'Buyer Broker Signed',
        cancelled: 'Cancelled',
        valuation_appointment: 'Valuation Appointment',
        listing_appointment: 'Listing Appointment',
        listing_signed: 'Listing Signed',
        dnc: 'DNC',
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: 'id',
                header: 'Sr no',
                size: 40,
                showColumnFilters: false,
                enableColumnFilter: false,
                muiTableBodyCellProps: {
                    align: 'left',
                },
            },
            {
                accessorFn: (row) => {
                    return row?.last_name === null
                        ? row?.first_name
                        : `${row?.first_name} ${row?.last_name}`;
                },
                header: 'Lead Name',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 150,
                muiTableHeadCellProps: {
                    align: 'left',
                },
                Cell: ({ row }) => (
                    <span
                        // onClick={() => navigate(`/admin-leads-details/${row.original.id}`)}
                        style={{ cursor: 'pointer', fontWeight: '500' }} // optional styling
                    >
                        {row?.original.last_name === null
                            ? row?.original.first_name
                            : `${row?.original.first_name} ${row?.original.last_name}`}
                    </span>
                ),
            },

            {
                accessorKey: 'email',
                header: 'Email',
                size: 100,
                // enableClickToCopy: true,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'phone',
                header: 'Phone Number',
                size: 50,
                enableSorting: false,
                showColumnFilters: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'status',
                enableSorting: false,
                header: 'Status',
                Cell: ({ cell }) => StatusDisplayMap[cell.getValue()] || cell.getValue(),
                size: 100,
                // filterSelectOptions:
                // filterVariant: 'select',
            },
            {
                accessorFn: (row) => {
                    const assignUserLead = row?.assign_user_leads?.[0];
                    const assignto = assignUserLead?.assignto;
                    if (!assignto) {
                        return '';
                    }
                    return assignto.last_name ? `${assignto.name} ${assignto.last_name}` : assignto.name;
                },
                header: 'Assign To',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorFn: (row) => {
                    const assignUserLead = row?.assign_user_leads?.[0];
                    const assignby = assignUserLead?.assignby;
                    if (!assignby) {
                        return '';
                    }
                    return assignby.last_name ? `${assignby?.name} ${assignby?.last_name}` : assignby.last_name;
                },
                header: 'Assign By',
                enableColumnActions: false,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
                size: 50,
                muiTableHeadCellProps: {
                    align: 'left',
                },
            },
            {
                accessorKey: 'assign_user_leads',
                header: 'Assign Date ',
                enableColumnActions: false,
                showColumnFilters: false,
                enableColumnFilter: false,
                enableSorting: true,
                size: 50,
                muiTableHeadCellProps: {
                    sx: {
                        fontSize: 'auto',
                    },
                },
                accessorFn: (row) => {

                    if (row?.assign_user_leads?.[0]?.updated_at && row?.assign === "2") {
                        const updatedAt = row?.assign_user_leads?.[0]?.updated_at;
                        const dateTime = new Date(updatedAt);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeOffSetAssignedAtForReceived(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
                // Cell: ({ row }) => {
                //     const updatedAt = row?.original?.assign_user_leads?.[0]?.updated_at;
                //     return <span>{updatedAt ? format(new Date(updatedAt), 'MMMM dd, yyyy') : null}</span>;
                // },
            },
            {
                accessorFn: (row) => {
                    if (row?.date && row?.time) {
                        const dateTimeString = `${row.date} ${row.time}`;
                        const dateTime = new Date(dateTimeString);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeBasedOnOffsetForReceivedData(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
                header: 'Appt Date/Time',
                size: 50,
                showColumnFilters: false,
                enableColumnFilter: false,
            },
            {
                // accessorKey: 'created_at',
                header: 'Created at',
                size: 100,
                showColumnFilters: false,
                enableSorting: true,
                enableColumnFilter: false,
                accessorFn: (row) => {
                    if (row?.created_at) {
                        const updatedAt = row?.created_at;
                        const dateTime = new Date(updatedAt);
                        const userOffset = getUserOffset();
                        const adjustedDateTime = adjustTimeOffSetAssignedAtForReceived(dateTime, userOffset);
                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                    }
                    return '';
                },
            },

            {
                accessorKey: 'source',
                header: 'Source',
                size: 100,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                accessorKey: 'lead_type',
                header: 'Lead Type',
                size: 100,
                showColumnFilters: false,
                enableSorting: false,
                enableColumnFilter: false,
            },

            {
                id: 'actions',
                enableSorting: false,
                accessorFn: (row) => row.id,
                showColumnFilters: false,
                enableColumnFilter: false,
                header: 'Action',
                size: 100,
                Cell: ({ row }) => (
                    <div style={{ display: 'flex', marginLeft: '5px' }}>
                        <IconButton aria-label="view" onClick={() => handleOpenDelete(row?.original?.id)}>
                            <DisabledByDefaultIcon />
                        </IconButton>
                    </div>
                ),
            },
        ],
        [navigate]
    );


    const GetAllLeads = async (

        currentPage,
        searchTerm = '',
        signal

    ) => {
        try {
            setLoading(true);
            const status = "requested_lead"
            const res = await LeadService.InvitedLeadByAdmin(currentPage, searchTerm, status, { signal });
            if (res?.data?.success) {
                setLeadData(res?.data?.leads?.data || []);
                setCurrentPage(res?.data?.leads?.current_page || 1);
                setTotalPages(Math.ceil((res?.data?.leads?.total || 0) / (res?.data?.leads?.per_page || 1)));
            } else {
                toast.error('Failed to fetch leads');
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };
    const throttledGetLeads = useCallback(
        throttle((page, searchTerm, signal) => {
            GetAllLeads(page, searchTerm, signal);
        }, 2000),
        []
    );

    const fetchLeads = useCallback(
        debounce((page, searchTerm,) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetLeads(page, searchTerm, abortController.signal);
        }, 300),
        [throttledGetLeads]
    );
    useEffect(() => {
        fetchLeads(currentPage, searchTerm,);
    }, [currentPage, searchTerm]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleClear = async () => {
        setCurrentPage(1);
        setSearchTerm('');
        await GetAllLeads(1, searchTerm);
    };

    const adjustTimeBasedOnOffsetForReceivedData = (date, offsetInHours) => {
        const adjustedDate = new Date(date);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);
        return adjustedDate;
    };

    const adjustTimeOffSetAssignedAtForReceived = (dateString, offsetInHours) => {
        const date = new Date(dateString);
        // Convert to UTC and then apply offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
        utcDate.setHours(utcDate.getHours() + offsetInHours);
        return utcDate;
    };

    const formatDateTimeIn12HourFormat = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM/PM
        hours = String(hours).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };
    const handleClose = () => {
        setDeleteId(null)
        setOpen(false);
    }
    const handleOpenDelete = (id) => {
        setDeleteId(id);
        setOpen(true);
    }
    const HandleDeleteId = async (deleteId) => {
        try {
            setDeleteLoading(true)
            const res = await LeadService.adminDeleteLeadRequest(deleteId)
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                fetchLeads(currentPage, searchTerm);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setDeleteLoading(false)
            setOpen(false);
        }
    }
    return (
        <>
            <ScrollAnimation animateIn='fadeIn'>
                <div >
                    <span style={{ fontSize: '26px', fontWeight: 'bold', padding: '10px' }} className='services-animated-text'>Invited Leads</span>
                </div>
                <Box >
                    <Box style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                        <TextField
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search by name , email"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={handleClear} aria-label="clear search">
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined"
                            sx={{
                                width: {
                                    xs: '150px',
                                    sm: '220px',
                                    md: '300px',
                                }, '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                },
                            }}
                        />
                    </Box>
                </Box>

                <>
                    <ThemeProvider theme={theme}>
                        <GlobalStyles
                            styles={{
                                '::-webkit-scrollbar': {
                                    width: '14px', // Set the desired width for the scrollbar
                                    height: '14px'
                                },
                                '::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                    borderRadius: '10px', // Set the border radius for a rounded effect
                                },
                            }}
                        />
                        {viewMode === 'list' ? (
                            <>
                                <div
                                    style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}
                                    className={classes.LeadTable}
                                >
                                    <MaterialReactTable
                                        columns={columns}
                                        data={LeadData}
                                        state={{ isLoading: isLoading }}
                                        muiCircularProgressProps={{
                                            color: 'secondary',
                                            thickness: 5,
                                            size: 55,
                                        }}
                                        muiSkeletonProps={{
                                            animation: 'pulse',
                                            height: 28,
                                        }}
                                        enableTopToolbar={false}
                                        enableFacetedValues={true}
                                        enableStickyHeader={true}
                                        enableDensityToggle={false}
                                        enableHiding={false}
                                        showSkeletons={false}
                                        enableColumnFilterModes={false}
                                        enableColumnActions={false}
                                        enableColumnOrdering={false}
                                        enableFullScreenToggle={false}
                                        enableColumnFilters={false}
                                        enablePagination={false}
                                        getRowId={(row) => row.id}
                                        initialState={{
                                            showColumnFilters: false,
                                            showGlobalFilter: false,
                                        }}
                                        muiTableBodyRowProps={{
                                            sx: {
                                                backgroundColor: '#f5f5f5', // Default row background color
                                                '&:nth-of-type(odd)': {
                                                    backgroundColor: '#ffffff', // Alternate rows with white
                                                },
                                                '&:hover': {
                                                    backgroundColor: '#e0e0e0', // Hover effect
                                                    cursor: 'pointer'
                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </>
                        ) : (
                            <div style={{
                                display: 'flex', flexWrap: 'wrap',
                                // justifyContent: 'flex-start', 
                                marginBottom: '40px',
                                marginLeft: '12px',
                                justifyContent: 'center'
                            }}>
                                {LeadData?.map((lead, index) => {

                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '1px solid #ccc',
                                                padding: '10px',
                                                margin: '10px',
                                                borderRadius: '5px',
                                                width: '180px',
                                                BoxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
                                            }}
                                        >
                                            {/* Customize the thumbnail view here */}

                                            <Avatar alt={lead?.first_name} src={logo_between} sx={{ mr: 2, width: 80, height: 80 }} />
                                            <div style={{ display: 'contents', height: '65px', }}>
                                                <span style={{ fontSize: '12px', fontWeight: 'bold' }}>{lead?.first_name} {lead?.last_name}</span>
                                                {/* <span style={{fontSize:'12px', }}>{lead?.email}</span> */}
                                                <span style={{ fontSize: '10px' }}>{StatusDisplayMap[lead?.status]}</span>
                                                <span style={{ fontSize: '10px' }}>AssignBy: {lead?.assign_user_leads?.[0]?.assignby?.name} {' '}{lead?.assign_user_leads?.[0]?.assignby?.last_name}</span>
                                                <span style={{ fontSize: '10px' }}>AssignTo:{lead?.assign_user_leads?.[0]?.assignto?.name}{' '}{lead?.assign_user_leads?.[0]?.assignto?.last_name}</span>
                                                <span style={{ fontSize: '10px' }}>Appt:{' '}
                                                    {lead?.date && lead?.time && (() => {
                                                        const dateTimeString = `${lead.date} ${lead.time}`;
                                                        const dateTime = new Date(dateTimeString);
                                                        const userOffset = getUserOffset();
                                                        const adjustedDateTime = adjustTimeBasedOnOffsetForReceivedData(dateTime, userOffset);
                                                        return formatDateTimeIn12HourFormat(adjustedDateTime);
                                                    })()}
                                                </span>
                                            </div>

                                            <IconButton aria-label="view" onClick={() => navigate(`/admin-leads-details/${lead.id}`)}>
                                                <VisibilityIcon />
                                            </IconButton>
                                        </div>
                                    )

                                })}
                            </div>
                        )}
                    </ThemeProvider>
                    <div style={{marginRight:'25px'}}>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        className={classes.PaginationLeadTable}
                    />
                    </div>
                </>

            </ScrollAnimation>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className='modal-resp-settings'>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box sx={{
                            display: 'grid',
                            padding: '10px',
                            gap: '10px',
                        }}>
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <CancelIcon onClick={handleClose} style={{ fontSize: '34px', cursor: 'pointer' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Are you sure you want to cancel  this Invitation?</span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>This action will delete this Lead permanently, and you can not undo this.</span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClose}
                                sx={{
                                    padding: {
                                        xs: '2px 8px',
                                        sm: '4px 15px',
                                        md: '6px 30px',
                                    },
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '12px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                    fontFamily: 'inherit'
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={() => HandleDeleteId(deleteId)}
                                disabled={deleteLoading}
                                variant='contained'
                                sx={{
                                    padding: {
                                        xs: '2px 8px',
                                        sm: '4px 15px',
                                        md: '6px 30px',
                                    },
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '12px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                    fontFamily: 'inherit'
                                }}

                            >
                                Delete
                            </Button>
                            <LinearProgress sx={{ visibility: deleteLoading ? '' : 'hidden' }} />
                        </Box>
                    </div>
                </Box>
            </Modal>
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />

        </>
    );
};

export default InvitedLeads;
